import {
  mdiAccount,
  mdiApps,
  mdiCalendarToday,
  mdiChevronDown,
  mdiChevronRight,
  mdiChevronUp,
  mdiClose,
  mdiHome,
  mdiMagnify,
  mdiMapMarker,
  mdiNewspaper,
  mdiShopping,
  mdiSilverware,
  mdiStar,
  // eslint-disable-next-line import/no-extraneous-dependencies
} from '@mdi/js';

export const mdiSvg = {
  account: mdiAccount,
  apps: mdiApps,
  calendarToday: mdiCalendarToday,
  chevronRight: mdiChevronRight,
  chevronDown: mdiChevronDown,
  chevronUp: mdiChevronUp,
  close: mdiClose,
  home: mdiHome,
  mapMarker: mdiMapMarker,
  magnify: mdiMagnify,
  newspaper: mdiNewspaper,
  silverware: mdiSilverware,
  shopping: mdiShopping,
  star: mdiStar,
};
